



















import Vue from "vue";
import MaskedInput from "vue-text-mask";
import emitter from "element-ui/src/mixins/emitter";

import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
  components: {
    MaskedInput,
  },

  mixins: [emitter],

  props: {
    /**
     * Value for the money field.
     */
    value: {
      type: String,
      default: "",
    },

    /**
     * Optional name for the field.
     */
    name: {
      type: String,
      default: "money",
    },

    /**
     * Placeholder for the field.
     */
    placeholder: {
      type: String,
      default: "affiliateProgram.questions.numericPlaceholder",
    },

    /**
     * Allows to define a custom mask to the field.
     */
    mask: {
      type: [Array, Function, Boolean, Object],
      default: () =>
        createNumberMask({
          allowDecimal: false,
          prefix: "",
          requirementDecimal: false,
          decimalLimit: 2,
          includeThousandsSeparator: true,
          thousandsSeparatorSymbol: ",",
          decimalSymbol: ".",
        }),
    },
  },

  data() {
    return {
      innerValue: "" as string,
    };
  },

  computed: {
    hasError(): boolean {
      return (this.$parent as any).validateState === "error";
    },

    placeholderText(): TranslateResult {
      return this.$t(this.placeholder, {
        number: "50,000",
      });
    },
  },

  watch: {
    value(newVal) {
      if (newVal !== this.innerValue) {
        (this as any).dispatch("ElFormItem", "el.form.change", [newVal]);
        this.innerValue = newVal;
      }
    },

    innerValue(newVal) {
      if (newVal !== this.value) {
        this.$emit("input", newVal);
        this.$emit("change", newVal);
        (this as any).dispatch("ElFormItem", "el.form.change", [newVal]);
      }
    },
  },

  created() {
    // Default value at start
    this.innerValue = this.value;
  },
});
